module.exports = __webpack_public_path__ + "img/product-preview-36.2021966.png";